export default {
    parts: [
        'container',
        'wrapper'
    ],
    baseStyle: (props) => ({
        container: {
            ...(!props?.isLast && (props?.ProductListDisplayModeWeb === 'VerticalList') && {
                borderBottom: {base: '1px solid', lg: 0},
                borderColor: {base: 'grey.400'},
                paddingBottom: {base: 2, lg: 0},
                marginBottom: {base: 2}
            }),
            ...(!props?.isLast && (props?.ProductListDisplayModeWeb === 'ModalVerticalList') && {
                borderBottom: {base: '1px solid'},
                borderColor: {base: 'grey.400'},
                paddingBottom: {base: 2},
                marginBottom: {base: 2}
            })
        }
    }),
    variants: {
        'ModalVerticalList': (props) => ({
            container: {
                display: 'flex'
            }
        })
    }
}
